import { CurrencyPipe } from "@angular/common";
import { Component, Input, OnInit, ViewChild } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { NbDialogRef } from "@nebular/theme";
import { of } from "rxjs";
import { debounceTime, distinctUntilChanged, switchMap } from "rxjs/operators";
import { ApiService } from "../services/api.service";
import { WalletService } from "../services/wallet.service";
import { DomSanitizer } from "@angular/platform-browser";

@Component({
  selector: "ngx-contribution-dialog",
  templateUrl: "./contribution-dialog.component.html",
  styleUrls: ["./contribution-dialog.component.scss"],
})
export class ContributionDialogComponent implements OnInit {
  @Input("tokenSymbol") tokenSymbol: string;
  @Input("tokenImage") tokenImage: string;
  @Input("contributionTokenSymbol") contributionTokenSymbol: string;
  @Input("contributionTokenImage") contributionTokenImage: string;
  @Input("tokenPrice") tokenPrice: any;
  @Input("minContribution") minContribution: number;
  @Input("maxContribution") maxContribution: number;
  @Input("crowdsaleID") crowdsaleID: number;

  contributeForm: FormGroup;

  public isTransactionPending: boolean = false;

  isCalculated: boolean;

  txInfo: any;

  constructor(
    protected dialogRef: NbDialogRef<ContributionDialogComponent>,
    protected _walletService: WalletService,
    protected _apiService: ApiService,
    private _formBuilder: FormBuilder,
    private _sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    this.contributeForm = this._formBuilder.group({
      payValue: new FormControl(this.minContribution, [
        Validators.max(this.maxContribution),
        Validators.min(this.minContribution),
      ]),
      payoutValue: new FormControl(
        this.minContribution / this.tokenPrice,
        Validators.min(0)
      ),
    });

    if (this.tokenPrice) {
      this.tokenPrice = parseFloat(this.tokenPrice);
      console.log(this.tokenPrice);

      this.isCalculated = false;
    }
  }
  updatingNumber1 = false;
  updatingNumber2 = false;

  updatePayoutValue() {
    const number1 = this.contributeForm.get("payValue").value;
    if (number1 && !this.updatingNumber1) {
      const number2 = parseFloat(number1) / this.tokenPrice; // example calculation
      this.updatingNumber2 = true;
      this.contributeForm.patchValue({ payoutValue: number2.toFixed(2) });
      this.updatingNumber2 = false;
    }
  }

  updatePayValue() {
    const number2 = this.contributeForm.get("payoutValue").value;
    if (number2 && !this.updatingNumber2) {
      const number1 = parseFloat(number2) * this.tokenPrice; // example calculation
      this.updatingNumber1 = true;
      this.contributeForm.patchValue({ payValue: number1.toFixed(2) });
      this.updatingNumber1 = false;
    }
  }

  sanitizeImgUrl(url) {
    return this._sanitizer.bypassSecurityTrustUrl(url);
  }

  onClose() {
    this.dialogRef.close();
  }

  async contribute() {
    this.isTransactionPending = true;
    // NEED TX TYPE
    // console.log(this.payValue);
    let userAddress = await this._walletService.getAddress();
    console.log(userAddress);
    this.txInfo = await this._walletService.sendTransactionMetamask(
      userAddress,
      this.contributeForm.controls.payValue.value
    );
    console.log(this.txInfo);
    console.log("contrib token symbol", this.contributionTokenSymbol);

    let txData = {
      txHash: this.txInfo.txHash,
      amount: this.contributeForm.controls.payValue.value,
      walletAddress: userAddress,
      crowdsaleID: this.crowdsaleID,
      amountInCustomToken: this.contributeForm.controls.payoutValue.value,
      paidTokenSymbol: this.contributionTokenSymbol,
      customTokenSymbol: this.tokenSymbol,
      tokensToBeReleased: this.contributeForm.controls.payoutValue.value,
    };
    console.log(txData);
    this.isTransactionPending = false;
    this._apiService.insertTransaction(txData).subscribe((res) => {});
    this.contributeForm.controls.payValue.setValue(0);
    this.contributeForm.controls.payoutValue.setValue(0);
  }
  getSearchData(value: string) {
    this.isCalculated = true;
    return of(value);
  }

  onPayoutInput(event) {
    console.log(event);
  }
}
